import { render, staticRenderFns } from "./Organizations.vue?vue&type=template&id=2d68978b&"
import script from "./Organizations.vue?vue&type=script&lang=js&"
export * from "./Organizations.vue?vue&type=script&lang=js&"
import style0 from "./Organizations.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d68978b')) {
      api.createRecord('2d68978b', component.options)
    } else {
      api.reload('2d68978b', component.options)
    }
    module.hot.accept("./Organizations.vue?vue&type=template&id=2d68978b&", function () {
      api.rerender('2d68978b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ddv-home/Organizations.vue"
export default component.exports